var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoolean(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    color: "#fff",
    viewBox: "0 0 300 128",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.821 124.938a8.34 8.34 0 01-5.914 2.451 8.34 8.34 0 01-5.913-2.451L3.769 77.705c-4.901-4.901-4.901-12.847 0-17.74l5.914-5.914c4.901-4.901 12.839-4.901 17.74 0l29.484 29.484 79.67-79.669c4.901-4.901 12.847-4.901 17.74 0l5.914 5.913c4.901 4.902 4.901 12.848 0 17.741l-97.41 97.418zM260.694 63.993l35.498-39.504c3.923-4.365 3.923-11.442 0-15.8l-4.732-5.266c-3.923-4.366-10.282-4.366-14.198 0l-35.499 39.503-35.498-39.511c-3.922-4.365-10.282-4.365-14.198 0l-4.739 5.267c-3.923 4.365-3.923 11.442 0 15.8l35.505 39.511-35.498 39.504c-3.923 4.365-3.923 11.442 0 15.8l4.732 5.266c3.923 4.366 10.282 4.366 14.198 0l35.498-39.503 35.499 39.503c3.922 4.366 10.282 4.366 14.198 0l4.732-5.266c3.923-4.366 3.923-11.442 0-15.8l-35.498-39.504z"
  }))));
}
export default SvgBoolean;